import { useRef, useState } from "react"
import { useConsole } from "contexts/Console"
import styled from "@emotion/styled"

import VideoPlayerCLD from "components/media/VideoPlayerCLD"
import Button from "components/button/Button"
import { legend100 } from "css/text"

const Launcher = styled.div`
  position: relative;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
`

const Label = styled.span`
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 1rem;
  white-space: nowrap;
  ${legend100}

  html.prefers-contrast & {
    color: black !important;

    ::after {
      background: white;
      content: "";
      height: calc(100% + 2px);
      left: 50%;
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
      width: calc(100% + 10px);
      z-index: -1;
    }
  }
`

export default function VideoLauncher(props) {
  const console = useConsole()
  const rvideo = useRef()
  const rfbutton = useRef()
  const [isAriaHidden, setIsAriaHidden] = useState(true)

  const {
    video_player_cld: { launcher_label, supporting_label, style, ...video_player_cld } = {},
    onChange,
    isLauncherButtonInline,
    titleId,
    key,
    ...rest
  } = props

  const onPress = () => {
    rvideo?.current?.play()
    setIsAriaHidden(false)
  }

  function onClose() {
    rfbutton.current.focus()
    setIsAriaHidden(true)
  }

  console.verbose("VideoLauncher(%o)", props)

  const launcherButton = (
    <Button
      isLauncherButtonInline={isLauncherButtonInline}
      ref={rfbutton}
      aria_label={video_player_cld?.aria_label}
      style={style}
      {...rest}
      onPress={onPress}
      icon='play'
      buttonId={titleId}
    >
      {launcher_label}
    </Button>
  )

  return (
    <>
      {supporting_label ? (
        <Launcher>
          {launcherButton}
          <Label>{supporting_label}</Label>
        </Launcher>
      ) : (
        launcherButton
      )}
      <VideoPlayerCLD aria_hidden={isAriaHidden} key={key} ref={rvideo} {...video_player_cld} onChange={onChange} onClose={onClose} />
    </>
  )
}
